import React, {useState} from 'react';
import {Text, buttonStyles} from '../../Atoms';
import {Stack} from '../../Layout';
import {Accordion, AccordionItemType} from '../Accordion/Accordion';
import clsx from 'clsx';
import styles from './FAQs.module.css';

type FAQsType = {
  faqs: AccordionItemType[];
  showAllFAQsButtonLabel: string;
  initialVisibleFAQs?: number;
};

export const FAQs = ({
  faqs,
  showAllFAQsButtonLabel,
  initialVisibleFAQs = 6,
}: FAQsType) => {
  const [hasAllFAQsVisible, setHasAllFAQsVisible] = useState(
    initialVisibleFAQs >= faqs.length
  );

  return (
    <div className={styles.root} data-cy="FAQsSection">
      <Stack align="start" space="lg">
        <div className={clsx(styles.accordionWrapper)}>
          <Accordion
            items={faqs}
            expandedItemId={faqs[0].id}
            visibleItems={hasAllFAQsVisible ? faqs.length : initialVisibleFAQs}
          />
        </div>
        {!hasAllFAQsVisible && (
          <button
            className={clsx(buttonStyles.button, styles.link)}
            onClick={() => {
              setHasAllFAQsVisible(!hasAllFAQsVisible);
            }}
            data-cy="ExpandAllFAQs"
          >
            <Text type="body">{showAllFAQsButtonLabel}</Text>
          </button>
        )}
      </Stack>
    </div>
  );
};
